import { render, staticRenderFns } from "./TextoResaltado.vue?vue&type=template&id=7f195506&"
import script from "./TextoResaltado.vue?vue&type=script&lang=js&"
export * from "./TextoResaltado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports